<ng-container *ngIf="data.success && shouldShowHypotheticalPerformance">
	<section *ngIf="!isFirstComponentOnPage" class="section-separator"></section>

	<!-- Hypothetical Portfolio Performance -->
	<div class="margin-standard">
		<h3 class="title-main" dcrContent dcrHTMLKey="PERFORMANCE_DETAILS">Hypothetical Portfolio Performance</h3>
		<label *ngIf="asOfDate">
			<h3 class="text-16 table-as-of-date">As of {{ asOfDate }}</h3>
		</label>
	</div>

	<section class="margin-bottom-20">
		<div class="row">
			<div class="col-24 d-flex justify-content-right">
				<div *ngIf="isCustomFeeEnabled">
					<cfe-custom-advisory-fee-dialog-button id="pa-custom-fee-dialog" [customAdvisoryFee]="customAdvisoryFee"></cfe-custom-advisory-fee-dialog-button>
				</div>
			</div>
		</div>

		<ac-combined-data-table class="col-12" [tabs]="tabs" [columnWidths]="columnWidths" [isStriped]="true" [isBordered]="true" [isPadded]="true"></ac-combined-data-table>

		<section class="disclaimer-container margin-standard"><p dcrHTMLKey="PERFORMANCE_ANNUALIZED">*Annualized</p></section>
	</section>

	<!-- Growth of Hypothetical Investment -->
	<section>
		<perf-hypothetical-performance-chart
			[data]="data"
			[customAdvisoryFee]="customAdvisoryFee"
			[showSimplifiedDisclaimer]="showSimplifiedDisclaimer"
			[isDisclosureExpandable]="isDisclosureExpandable"
			[isCustomFeeEnabled]="isCustomFeeEnabled"
		></perf-hypothetical-performance-chart>
	</section>
	<section *ngIf="isFirstComponentOnPage" class="section-separator"></section>
</ng-container>
